"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceTransparencyCarousel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var react_1 = require("swiper/react");
var swiper_1 = require("swiper");
swiper_1.default.use([swiper_1.Navigation]);
var PriceTransparencyCarousel = /** @class */ (function (_super) {
    __extends(PriceTransparencyCarousel, _super);
    function PriceTransparencyCarousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSlideChange = function (swiper) { return _this.props.setActiveIndex(swiper.realIndex); };
        _this.getSwiperInstance = function (swiper) { return _this.swiper = swiper; };
        _this.renderCarouselItems = function () {
            return _this.props.data.map(function (entry) { return ((0, jsx_runtime_1.jsx)(react_1.SwiperSlide, { className: entry.name + "-slide d-flex align-items-center", children: (0, jsx_runtime_1.jsx)("div", { children: entry.description }) })); });
        };
        return _this;
    }
    PriceTransparencyCarousel.prototype.render = function () {
        if (this.swiper && this.swiper.realIndex !== this.props.activeIndex) {
            this.swiper.slideToLoop(this.props.activeIndex);
        }
        return ((0, jsx_runtime_1.jsx)("div", { className: "price-transparency-carousel " + this.props.className, children: (0, jsx_runtime_1.jsx)(react_1.Swiper, { initialSlide: this.props.activeIndex, loop: true, navigation: true, centeredSlides: true, slidesPerView: "auto", onSlideChange: this.handleSlideChange, onSwiper: this.getSwiperInstance, children: this.renderCarouselItems() }) }));
    };
    return PriceTransparencyCarousel;
}(React.Component));
exports.PriceTransparencyCarousel = PriceTransparencyCarousel;
//# sourceMappingURL=PriceTransparencyCarousel.js.map